// extracted by mini-css-extract-plugin
export default {"paper":"paper__ukPf4","popper":"popper__52eFA","left":"left__eZLM3","profiles-list":"profiles-list__HDTsY","avatar":"avatar__5oGey","avatar-empty":"avatar-empty__HD+ma"};